<div class="ws-app-component">
  <router-outlet></router-outlet>
</div>
